import './src/styles/tailwind-base.css'
import React from "react"
import { Provider } from "react-redux"
import createStore from "./src/state/createStore"

// Wrapping the Gatsby app with the Provider component
export const wrapRootElement = ({ element }) => {
  const store = createStore()
  return (
    <Provider store={store}>
      {element}
    </Provider>
  )
}

// The retired HubSpot loader is disabled. PrivacyChoices manages optional
// analytics initialization; do not add a second tracking loader here.

